import { ComponentChild, FunctionComponent } from "preact";

// TODO: Any sort or filter... (that could be part of the header definition or better as arrays?)
const DataTable: FunctionComponent<{
  klass?: string, header: ComponentChild[], rows: ComponentChild[][]
}> = ({ klass, header, rows }) => {
  return <table class={ 'data-table ' + (klass ?? '') }>
    <tr>{ header.map(h => <th>{h}</th>)}</tr>
    { rows.map(r => <tr>{ r.map(v => <td>{ v }</td> ) }</tr>) }
  </table>;
}

export default DataTable;
